<template>
  <div class="time-diff-input">
    <b-field label="Day Difference">
      <b-field>
        <b-select
          v-model.number="sign"
          class="time-diff-input__sign-input"
          @input="inputHandler"
        >
          <option :value="1">+</option>
          <option :value="-1">-</option>
        </b-select>
        <b-input
          v-model.number="daysLength"
          class="time-diff-input__days-input"
          type="number"
          min="0"
          @input="inputHandler"
        >
        </b-input>
      </b-field>
    </b-field>
    <b-field label="Time Difference">
      <b-field>
        <b-select
          v-model.number="sign"
          class="time-diff-input__sign-input"
          @input="inputHandler"
        >
          <option :value="1">+</option>
          <option :value="-1">-</option>
        </b-select>
        <b-timepicker
          v-model="timeLengthForDatePicker"
          class="time-diff-input__date-input"
          :increment-minutes="30"
          @input="inputHandler"
        >
        </b-timepicker>
      </b-field>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    const timeLength = Math.abs(this.value) % (24 * 60);
    const sign = this.value < 0 ? -1 : 1;

    const timeLengthForDatePicker = new Date(
      0,
      0,
      0,
      Math.floor(timeLength / 60),
      timeLength % 60
    );
    return {
      sign,
      daysLength: Math.floor(Math.abs(this.value) / (24 * 60)),
      timeLengthForDatePicker
    };
  },
  methods: {
    inputHandler() {
      const hours = this.timeLengthForDatePicker.getHours();
      const minutes = this.timeLengthForDatePicker.getMinutes();
      this.$emit(
        'input',
        this.sign * (24 * 60 * this.daysLength + (hours * 60 + minutes))
      );
    }
  }
};
</script>

<style scoped lang="scss">
.time-diff-input {
  display: inline-block;
  &__sign-input,
  &__date-input,
  &__days-input {
    max-width: 4rem;
  }
}
</style>
